import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

const validateEmailDomainFn = httpsCallable(functions, 'validateEmailDomain');

/**
 * Check that an email's domain can actually receive mail (DNS MX/A).
 * Returns { valid: boolean, reason }. Fails OPEN (valid:true) if the check itself
 * is unavailable, so signup is never blocked by an infra hiccup.
 */
export const validateEmailDomain = async (email) => {
  try {
    const res = await validateEmailDomainFn({ email });
    return res.data || { valid: true, reason: 'no-data' };
  } catch (e) {
    return { valid: true, reason: 'unavailable' };
  }
};
